import { useRef, useEffect } from 'react';
import * as echarts from 'echarts';
import { ipRank } from '@/apis/statistics';
import { useState } from 'react';

const UserIp = () => {
	const chartRef = useRef(null);
	const [dataArr, setDataArr] = useState([])
	const getList = () => {
		ipRank().then(res => {
			const arr = res.data.map(item => {
				return {
					name: item.name,
					value: item.count
				}
			})
			setDataArr(arr)
		})
	}
	useEffect(() => {
		getList();
	}, [])
	useEffect(() => {
		if (dataArr.length > 0) {
			const chartDom = chartRef.current;
			const myChart = echarts.init(chartDom);
			const total = dataArr.map(item => item.value).reduce((a, b) => a + b)

			const option = {
				legend: {
					type: 'scroll',
					orient: 'vertical',
					right: '0',
					icon: 'square',
					itemWidth: 10,
					itemHeight: 10,
					top: '10%',
					formatter: function (name) {
						// 添加
						let target = 0
						let precent = 0
						for (let i = 0; i < dataArr.length; i++) {
							if (dataArr[i].name === name) {
								target = dataArr[i].value
								precent = ((dataArr[i].value / total) * 100).toFixed(1)
							}
						}

						var arr = [
							'{a|' + name + '}',
							// '{b|' + target + '}',
							// '{c|个}',
							'{b|' + precent + '}',
							'{c|%}'
						]
						return arr.join('  ')
					},
					textStyle: {
						// 添加
						rich: {
							a: {
								fontSize: 12,
								color: 'rgba(0,0,0,0.7)',
							},
							b: {
								fontSize: 14,
								color: '#000',
								fontFamily: 'DIN-Regular'
							},
							c: {
								fontSize: 10,
								color: 'rgba(0,0,0,0.7)',
								// width: 16
							}
						}
					}
				},

				series: [
					{
						name: '',
						type: 'pie',
						radius: '45%',
						center: ['22%', '49%'],
						label: {
							show: false,
							position: 'center',
							formatter: param => {
								// const val = ((param.value / total) * 100).toFixed(1)
								// const arr = ['{b|' + param.name + '\n}', `{a|${val}}`, `{b|% }`]
								const arr = ['{b|' + param.name + '\n}', `{a|${param.value}}`, `{b|个 }`]
								return arr.join(' ')
							},
							color: '#d62293',
							rich: {
								a: {
									fontSize: 16,
									fontFamily: 'DIN-Regular'
								},
								b: {
									fontSize: 14
								}
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: dataArr,
						itemStyle: {
							normal: {
								color: function (params) {
									var colorList = [
										['rgba(217, 175, 217,0.1)', '#d9afd9'],
										['rgba(112, 40, 228,0.1)', '#7028e4 '],
										['rgba(254, 81, 150,0.1)', '#fe5196'],
										['rgba(171, 236,214,0.1)', '#abecd6'],
										['rgba(62, 137, 253,0.1)', '#3E89FD'],

										['rgba(250, 172, 168,0.1)', '#faaca8'],
										['rgba(104, 187, 196,0.1)', '#68bbc4'],
										['rgba(247, 112, 98,0.1)', '#f77062'],
										['rgba(146, 254, 157,0.1)', '#92fe9d'],
										['rgba(251, 237, 150,0.1)', '#fbed96'],
									]
									var index = params.dataIndex
									return new echarts.graphic.LinearGradient(0, 0, 1, 1, [
										{
											offset: 0,
											color: colorList[index][0]
										},
										{
											offset: 1,
											color: colorList[index][1]
										}
									])
								}
							}
						}
					}
				]
			};
			myChart.setOption(option);
			window.addEventListener('resize', () => {
				myChart && myChart.resize();
			});
			return () => {
				myChart.dispose();
			};
		}

	}, [dataArr]);


	return <div ref={chartRef}>曲线图</div>
}
export default UserIp;